import React, {Component} from 'react';
import {translate} from 'react-i18next';
import BackNextButtons from './components/back_next_buttons';
import swal from 'sweetalert';
import WaitingModal from '../generics/WaitingModal';

var Config = require('../../config');

class SearchPatient extends Component{
	constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.showCtrlError = this.showCtrlError.bind(this);
        this.isValidForm = this.isValidForm.bind(this);
        this.search = this.search.bind(this);
        this.getNextRoute = this.getNextRoute.bind(this);
        
        this.state = {
            number:"",
            nextStatus:"",
            patient:{},
            person:{},
            last_sample:null,
            last_sample_date:"",
            nextRoute:""		
		}
	}

	componentDidMount(){
	}

	componentDidUpdate(){
    }
    
    handleChange(event){
		this.setState({[event.target.name] : event.target.value});
		
        var control = document.getElementById(event.target.id);
        if(control !== null){
            if(control.required && control.className.includes('error')){
                control.classList.remove('error');
            }else if(control.required && event.target.value===""){
                control.classList.add('error');
            }
        }
    }

    onEnter(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
  			e.preventDefault(); // Prevent form submission if button present
            if(this.isValidForm()){
                this.search();
            }
        }
    }
      
    search(){
        this.waiting_modal.handleShow('Buscando...');
        fetch(Config.default.apiGateway.URL+'patients/search_by_number?number='+this.state.number,{ 
            method: 'get',
            headers: new Headers({
               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
               'Accept': 'application/json',
                'Content-Type': 'application/json',
            })
        })
        .then(res => {
            this.waiting_modal.handleClose();
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
                return;
              });
            }})
        .then(response => {
            if(response !== undefined){
                this.setState({
                    person:response.person,
                    patient:response.patient,
                    nextStatus:"dataLoaded", 
                    last_sample:response.last_sample,
                    last_sample_date:response.last_sample_date
                });
            }else{
                this.setState({person:{},patient:{},nextStatus:"",last_sample:{},last_sample_date:""});
            }
        });
    }
    
    getNextRoute(){
        return "/transfusional_control/sample_data/"+this.state.patient.id+"/"+this.state.patient.number;
    }
    
    isValidForm() {
		const inputs = document.querySelectorAll('input');
	    let isFormValid = true;

	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}	   
		  	}
        });
        
        if(!isFormValid)
            swal('¡Error!', "Campos incompletos", 'error');
	    
	    return isFormValid;
    }
    
    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
	}

	render(){
		const {t} = this.props;

		return (
            <div className="container">
                <h3>Datos del Paciente</h3>
                <div className="col-xs-12 form-group" >
                    <div className="col-xs-12">
                        <span>Historia Clínica</span>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <input type="text" value={this.state.number || ""}  id="number" name="number" className="form-control"
                        onChange={this.handleChange} required onEnter={this.search} onKeyPress={(e) => this.onEnter(e)}/>
                    </div>
                </div>
                <div className="col-xs-12 form-group" style={{textAlign:"center"}}>
                    {this.state.person.names !== undefined?
                        <div>
                            <h4>{this.state.person.names+' '+this.state.person.lastname1+' '+this.state.person.lastname2}</h4>
                            {this.state.person.lookup_group !== null?
                            <h1 style={{color:"red"}}>{this.state.person.lookup_group+(this.state.person.lookup_rh==="POSITIVO"?"+":
                                                                    this.state.person.lookup_rh==="NEGATIVO"?"-":"")}</h1>
                                                                    :null}
                        </div>
                        :""}
                    {this.state.last_sample !== null?
                        <div>
                            <h5>Última muestra registrada {this.state.last_sample.number}</h5>
                            <h5>Fecha: {this.state.last_sample_date}</h5>
                        </div>
                        :null
                    }
                </div>
                <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
                <BackNextButtons history={this.props.history} nextStatus={this.state.nextStatus} number={this.state.number} 
                    isValidForm={this.isValidForm} search={this.search} getNextRoute={this.getNextRoute}
                    showBack={true} showNext={true}/>
            </div>
		)	
	}
} 

export default translate('translations') (SearchPatient);